/**
 * @generated SignedSource<<c67e737e307433e294d3f980f8ad2045>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type DeletePopupGroupInput = {
  clientMutationId?: string | null;
  popupGroupId: string;
};
export type FunnelPopupGroupTableActions_DeleteMutation$variables = {
  connections: ReadonlyArray<string>;
  input: DeletePopupGroupInput;
};
export type FunnelPopupGroupTableActions_DeleteMutationVariables = FunnelPopupGroupTableActions_DeleteMutation$variables;
export type FunnelPopupGroupTableActions_DeleteMutation$data = {
  readonly deletePopupGroup: {
    readonly deletedPopupGroupId: string;
  } | null;
};
export type FunnelPopupGroupTableActions_DeleteMutationResponse = FunnelPopupGroupTableActions_DeleteMutation$data;
export type FunnelPopupGroupTableActions_DeleteMutation = {
  variables: FunnelPopupGroupTableActions_DeleteMutationVariables;
  response: FunnelPopupGroupTableActions_DeleteMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "connections"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "deletedPopupGroupId",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "FunnelPopupGroupTableActions_DeleteMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "DeletePopupGroupPayload",
        "kind": "LinkedField",
        "name": "deletePopupGroup",
        "plural": false,
        "selections": [
          (v2/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "FunnelPopupGroupTableActions_DeleteMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "DeletePopupGroupPayload",
        "kind": "LinkedField",
        "name": "deletePopupGroup",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "filters": null,
            "handle": "deleteEdge",
            "key": "",
            "kind": "ScalarHandle",
            "name": "deletedPopupGroupId",
            "handleArgs": [
              {
                "kind": "Variable",
                "name": "connections",
                "variableName": "connections"
              }
            ]
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "614b48ea74d1ef5a41f2435956c23516",
    "id": null,
    "metadata": {},
    "name": "FunnelPopupGroupTableActions_DeleteMutation",
    "operationKind": "mutation",
    "text": "mutation FunnelPopupGroupTableActions_DeleteMutation(\n  $input: DeletePopupGroupInput!\n) {\n  deletePopupGroup(input: $input) {\n    deletedPopupGroupId\n  }\n}\n"
  }
};
})();

(node as any).hash = "718bac805c2223083af5f4f372afc078";

export default node;
